/**
 * Factories de estado con valores por defecto sensatos. Los módulos de
 * combate/plinko/cartas/meta consumen y mutan (de forma controlada) estos
 * objetos; aquí solo vive la construcción inicial, sin lógica de juego.
 */

import type { MetaState, RunStats, RunState } from './types';

/** Stats de combate en cero — punto de partida de toda run nueva. */
export function createDefaultRunStats(): RunStats {
  return {
    atkPct: 0,
    critPct: 0,
    maxHpPct: 0,
    armor: 0,
    lifestealPct: 0,
    bonusProjectiles: 0,
    blockPct: 0,
    doubleAtkPct: 0,
    enemyMissPct: 0,
    nextWaveAtkPct: 0,
  };
}

export interface CreateRunStateOptions {
  chapterId: string;
  totalWaves: number;
  baseHp?: number;
}

/** Crea el estado inicial de una run nueva para un capítulo dado. */
export function createRunState(options: CreateRunStateOptions): RunState {
  const baseHp = options.baseHp ?? 100;
  return {
    chapterId: options.chapterId,
    wave: 1,
    totalWaves: options.totalWaves,
    balls: 0,
    hp: baseHp,
    maxHp: baseHp,
    reviveUsed: false,
    stats: createDefaultRunStats(),
    boardMods: [],
    speed: 1,
  };
}

/** Crea el estado meta por defecto para un jugador nuevo (sin partida previa). */
export function createDefaultMetaState(): MetaState {
  return {
    coins: 0,
    gems: 0,
    xp: 0,
    level: 1,
    upgrades: { atk: 0, hp: 0, def: 0 },
    gear: [],
    equipped: {},
    chapterProgress: 0,
    saveVersion: 1,
  };
}
